import React from 'react'
import { Field } from 'redux-form/immutable'
import { withTranslation } from 'react-i18next'
import cn from 'classnames'

import UserActivityAddToFavorites from 'app/domains/common/AddToFavorites'
import RatedStars from 'app/components/RatedStars'
import { required } from 'helpers/validators'

import './styles.scss'

const isRequired = required('Please add a rating')

const UserActivityDonePanelActions = ({ t, i18n: { language }, activityId, isFavorite, isYesterday }) => (
  <div className="user-activity-done-panel-actions">
    <div className="user-activity-done-panel-actions__inner">
      <UserActivityAddToFavorites
        activityId={activityId}
        highlightFavoriteIcon={isFavorite}
        isYesterday={isYesterday}
      />
      <div
        className={cn(`user-activity-done-panel-actions__rate`, {
          [`user-activity-done-panel-actions__rate__${language}`]: language,
        })}
      >
        <div className="user-activity-done-panel-actions__rate-text">{t('Please rate this activity')}</div>
        <Field name="rate" component={RatedStars} validate={[isRequired]} />
      </div>
    </div>
  </div>
)

export default withTranslation('user')(UserActivityDonePanelActions)
